<section class="entercode">
	<ng-content select="[before]"></ng-content>

	<cmv-loader-message *ngIf="isOtpValidating"
		>Validando código</cmv-loader-message
	>
	<cmv-loader-message *ngIf="isOtpSending">Enviando código</cmv-loader-message>

	<form class="entercode__form" [formGroup]="enterCodeForm">
		<h3 class="entercode__section-title">CÓDIGO</h3>

		<div class="entercode__field">
			<label class="entercode__label" for="enterCodeInput"
				>Escribe o pega el código</label
			>
			<div class="entercode__input-pill" #otpInput>
				<i class="bi bi-phone-fill"></i>
				<input
					id="enterCodeInput"
					type="text"
					inputmode="numeric"
					formControlName="enterCode"
					placeholder="Código de verificación"
					autocomplete="one-time-code"
					(input)="onKeyupEnterCode()"
					maxlength="6" />
			</div>
			<cmv-error-message *ngIf="enterCodeField.errors?.['pattern']">
				Código debe ser de {{ enterCodeLength }} dígitos
			</cmv-error-message>
		</div>

	</form>

	<ng-content select="[after-otp]"></ng-content>

	<div class="entercode__resend">
		<div class="entercode__resend-info">
			<p class="entercode__problems">¿Tienes problemas?</p>
			<p class="entercode__timer" *ngIf="otpForwardingTimeout > 0">
				Espera
				<strong class="entercode__timer-number">{{
					otpForwardingTimeout
				}}</strong>
				segundos
			</p>
			<button
				*ngIf="otpForwardingTimeout <= 0"
				cmvBtn="link"
				class="entercode__resend-btn"
				(click)="onReSendOptCode()">
				Reenviar el código
			</button>
		</div>
		<ng-content select="[after-resend]"></ng-content>
	</div>

	<section>
		<button
			type="button"
			[hidden]="
				(!isOtpNotReceivedButonEnabled && !isOtpValidated) ||
				notReceivedOtpButtonHasBeenClicked
			"
			cmvBtn="link"
			(click)="onNotifyOtpNoReceived()">
			Reportar que no recibí el código de verificación
		</button>
	</section>
</section>
